import styled from 'styled-components';

const ApplyStyledContainer = styled.div``;

export default ApplyStyledContainer;
